import { Component, inject, OnInit, Signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { ButtonModule, DialogModule, InputModule } from '@sag-ui';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { select, Store } from '@ngxs/store';
import { ReportState } from './state/report.state';
import { DownloadLegacyReport, DownloadReport, LoadReports, RequestReport } from './state/report.action';
import { IUser } from '@cod-monorepo/interfaces';
import { UserState } from '../user-management/state/user-management.state';
import { filter, Observable, tap } from 'rxjs';

@Component({
    selector: 'app-report',
    standalone: true,
    imports: [
        CommonModule,
        ButtonModule,
        TranslateModule,
        RouterModule,
        InputModule,
        DialogModule,
        FormsModule,
        ReactiveFormsModule
    ],
    templateUrl: './report.component.html'
})
export class ReportComponent implements OnInit {
    public requesting: Signal<boolean> = select(ReportState.requesting);
    public downloading: Signal<boolean> = select(ReportState.downloadingLegacy);
    public reports: Signal<string[]> = select(ReportState.reports);
    public user$: Observable<IUser | undefined> = inject(Store).select(UserState.user);

    public emailControl = new FormControl('');

    constructor(private store: Store) {}

    ngOnInit(): void {
        this.initUserEmail();
        this.loadReports();
    }

    public requestReport(): void {
        const email = this.emailControl.value;

        if (!email) {
            return;
        }

        this.store.dispatch(new RequestReport(email));
    }

    public downloadReport(reportName: string): void {
        this.store.dispatch(new DownloadReport(reportName));
    }

    public downloadLegacyReport(): void {
        this.store.dispatch(new DownloadLegacyReport());
    }

    private initUserEmail(): void {
        this.user$
            .pipe(
                filter(user => !!user),
                tap(user => this.emailControl.setValue(user?.email))
            )
            .subscribe();
    }

    private loadReports(): void {
        this.store.dispatch(new LoadReports());
    }
}
